import * as Config from '../../../config';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import AutomixToggleButton from './AutomixToggleButton';

import { setStackAutomix } from "./redux/actions/index";

// ON LIST COLUMNS
function ConnectedAutomixStandAloneButton({ pathApi, uid, from, className, style, api, enabled, setStackAutomix, isShow = true }) {
  useEffect( () => {
    if (api && pathApi) {
      api.getFromApi(pathApi).then( (response) => {
        const dataResults = response.data.results;
        const dataResultsFormatted = dataResults.map(Config.formattedFromBP);
        setStackAutomix({ uid, tracks: dataResultsFormatted.map( x => { /*x.from = from;*/ return x } ), from, active: 0, next: response.data.next });
      }).catch( e => {} );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, pathApi]);

  return (enabled && isShow) ? <AutomixToggleButton uid={uid} idPlaylist={uid} className={className} style={style} /> : null
}

ConnectedAutomixStandAloneButton.propTypes = {
  pathApi: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
  from: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  isShow: PropTypes.bool
}

const AutomixStandAloneButton = connect(
  state => ({
    api: state.api,
    enabled: state.enabledAutomix
  }),
  dispatch => ({
    setStackAutomix: stack => dispatch(setStackAutomix(stack))
  }) )
(ConnectedAutomixStandAloneButton);

export default AutomixStandAloneButton;
